/** Internal presentation cadence in simulation ticks. */
export interface GraphicsCadence { readonly intervalTicks: number; readonly shouldReconcile: (tick: number) => boolean; readonly reset: () => void; }
export function createGraphicsCadence(intervalTicks = 1): GraphicsCadence {
  if (!Number.isInteger(intervalTicks) || intervalTicks < 1) throw new Error(`graphics cadence must be a positive integer, got ${String(intervalTicks)}`);
  let last: number | null = null;
  return {
    intervalTicks,
    shouldReconcile(tick) {
      if (last !== null && tick < last) last = null;
      if (last === null || tick - last >= intervalTicks) {
        last = tick;
        return true;
      }
      return false;
    },
    reset() { last = null; },
  };
}
